import React from "react";
import styled from "styled-components";
import { colors } from "../../../../../theme";
import { POINTER_HOVER_MEDIA } from "../../../../styles/pointer-hover";

//styles
const ExpertiseSection = styled.section`
  margin-bottom: 1.5rem;
`;

const SectionLabel = styled.div`
  margin-bottom: 10px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
`;

const ExpertiseList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const ExpertiseTag = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  max-width: 100%;
  padding: 0.25rem 0.75rem;

  font-size: 0.75rem;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  color: ${colors.linkHover.dark};
  background: ${colors.surface};

  border-radius: 9999px;
  border: 1px solid ${colors.form.border};

  transition: background-color 150ms ease, color 150ms ease,
    border-color 150ms ease;

  @media ${POINTER_HOVER_MEDIA} {
    &:hover {
      background: ${colors.accentLight};
      border-color: ${colors.linkHover.light};
      color: ${colors.linkHover.dark};
    }
  }
`;

const EXPERTISE = [
  "Data visualization",
  "Dashboard",
  "Accessibility development",
  "GatsbyJS",
  "Analytics development",
  "Web development",
  "Front end",
  "CSS",
  "React.js",
  "JavaScript",
  "HTML5",
  "Next.js",
  "Redux",
  "Stripe development",
];

export default function Expertise() {
  return (
    <ExpertiseSection>
      <SectionLabel>Expertise</SectionLabel>

      <ExpertiseList>
        {EXPERTISE.map((label) => (
          <ExpertiseTag key={label} data-testid="skill-tag">
            {label}
          </ExpertiseTag>
        ))}
      </ExpertiseList>
    </ExpertiseSection>
  );
}
